<div class="qc-lab-req">
    <form *ngIf="form" [formGroup]="form">
        <div class="grid">
            <div style="display: flex; flex-direction: column">
                <div>
                    <app-sk-health-authority-logo />
                </div>
                <div
                    style="
                        text-align: right;
                        font-size: 18px;
                        font-weight: bold;
                    "
                >
                    Saskatoon Area
                </div>
                <div class="bordered no-border-bottom padding grow">
                    <div
                        style="
                            font-size: 24px;
                            font-weight: bolder;
                            text-transform: uppercase;
                        "
                    >
                        Community Lab Requisition
                    </div>
                    <div class="group">
                        <div style="margin-right: 10px">
                            <label class="bold">Requesting physician:</label>
                        </div>
                        <div style="flex: 33%">
                            <input
                                formControlName="requestingPhysicianFirstName"
                                type="text"
                            />
                            <label class="dimmed">(first name)</label>
                        </div>
                        <div style="flex: 33%">
                            <input
                                formControlName="requestingPhysicianLastName"
                                type="text"
                            />
                            <label class="dimmed">(last name)</label>
                        </div>
                    </div>
                    <div class="group">
                        <div style="margin-right: 10px">
                            <label class="bold"
                                >Additional copies of report to:</label
                            >
                        </div>
                        <div class="grow">
                            <input
                                formControlName="additionalCopiesOfReportTo"
                                type="text"
                            />
                        </div>
                    </div>
                    <div class="group">
                        <div style="margin-right: 10px">
                            <label class="bold no-break"
                                >Collection date:</label
                            >
                        </div>
                        <div>
                            <input
                                formControlName="collectionDate"
                                type="text"
                            />
                        </div>
                        <div style="margin-right: 10px">
                            <label class="bold">Time:</label>
                        </div>
                        <div>
                            <input
                                formControlName="collectionTime"
                                type="text"
                            />
                        </div>
                    </div>
                </div>
                <div class="bordered no-border-bottom padding">
                    <div style="display: flex; gap: 10px">
                        <label class="bold">Other tests:</label>
                        <label class="dimmed">(print clearly)</label>
                    </div>
                    <textarea
                        formControlName="otherTests"
                        class="no-border-bottom"
                        rows="6"
                        style="
                            white-space: pre-wrap;
                            overflow-wrap: anywhere;
                            word-break: break-word;
                        "
                    ></textarea>
                </div>
            </div>

            <div style="display: flex; flex-direction: column">
                <div class="padding">
                    <div class="group">
                        <div style="margin-right: 10px">
                            <label class="dimmed"
                                >Clinic name or billing info:</label
                            >
                        </div>
                        <div class="grow">
                            <input
                                formControlName="clinicNameOrBillingInfo"
                                type="text"
                            />
                        </div>
                    </div>
                    <div class="group">
                        <div style="margin-right: 10px">
                            <label class="dimmed">PHN:</label>
                        </div>
                        <div style="flex: 33%">
                            <input formControlName="PHN" type="text" />
                        </div>
                        <div style="margin-right: 10px">
                            <label class="dimmed">Chart #:</label>
                        </div>
                        <div style="flex: 33%">
                            <input formControlName="chartNo" type="text" />
                        </div>
                    </div>
                    <div class="group">
                        <div style="margin-right: 10px">
                            <label class="dimmed">Name:</label>
                        </div>
                        <div style="flex: 33%" class="text-center">
                            <input formControlName="firstName" type="text" />
                            <label class="dimmed">(first)</label>
                        </div>
                        <div style="flex: 33%" class="text-center">
                            <input formControlName="lastName" type="text" />
                            <label class="dimmed">(last)</label>
                        </div>
                    </div>
                    <div class="group" style="gap: 15px">
                        <app-sk-profile-checkbox name="male" label="Male" />
                        <app-sk-profile-checkbox name="female" label="Female" />
                    </div>
                    <div class="group">
                        <div style="margin-right: 10px">
                            <label class="dimmed">DOB:</label>
                        </div>
                        <div style="flex: 33%" class="text-center">
                            <input formControlName="DOB" type="text" />
                            <label class="dimmed">(DD/MM/YYYY)</label>
                        </div>
                        <div style="margin-right: 10px">
                            <label class="dimmed">Phone:</label>
                        </div>
                        <div style="flex: 33%" class="text-center">
                            <input
                                formControlName="phone"
                                type="text"
                                style="margin-bottom: 1rem"
                            />
                        </div>
                    </div>
                </div>
                <div class="bordered no-border-bottom no-border-left padding">
                    <div class="text-center">
                        <label class="bold">Therapeutic Drug Testing</label>
                    </div>
                    <div style="display: flex; flex-wrap: nowrap">
                        <div style="flex: 55%">
                            <app-sk-test-checkbox
                                code="CARBZ"
                                label="Carbamazepine (Tegretol)"
                            />
                            <app-sk-test-checkbox code="DIGI" label="Digoxin" />
                            <app-sk-test-checkbox code="LITH" label="Lithium" />
                            <app-sk-test-checkbox
                                code="PHENB"
                                label="Phenobarbital"
                            />
                            <app-sk-test-checkbox
                                code="PTNY"
                                label="Phenytoin (Dilantin)"
                            />
                            <app-sk-test-checkbox
                                code="VALPR"
                                label="Valproic Acid (Epival)"
                            />
                        </div>
                        <div style="flex: 45%">
                            <app-sk-test-checkbox
                                code="CYCL"
                                label="Cyclosporin - Pre"
                            />
                            <app-sk-test-checkbox
                                code="CY2"
                                label="Cyclosporin - Post"
                            />
                            <app-sk-test-checkbox
                                code="TACR"
                                label="Tacrolimus - Pre"
                            />
                            <app-sk-test-checkbox
                                code="SIRO"
                                label="Sirolimus - Pre"
                            />
                            <div class="group" style="margin-top: 0">
                                <div style="margin-right: 10px">
                                    <label>Dosage:</label>
                                </div>
                                <div style="flex: 1">
                                    <input
                                        formControlName="therapeuticDosage"
                                        type="text"
                                    />
                                </div>
                                <div style="margin-left: 10px">(Required)</div>
                            </div>
                            <div class="group" style="margin-top: 0">
                                <div style="margin-right: 10px">
                                    <label>Date/Time:</label>
                                </div>
                                <div style="flex: 1">
                                    <input
                                        formControlName="therapeuticDateTime"
                                        type="text"
                                    />
                                </div>
                                <div style="margin-left: 10px">(Required)</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div style="display: flex; flex-direction: column">
                <div class="bordered no-border-bottom padding">
                    <app-sk-test-checkbox code="CBC" label="CBC (&diff)" />
                    <app-sk-test-checkbox
                        code="ARETC"
                        label="Reticulocyte Count"
                    />
                    <app-sk-test-checkbox code="DDIM" label="D-Dimer" />
                    <app-sk-test-checkbox code="FIB" label="Fibrinogen Level" />
                    <app-sk-test-checkbox code="PT" label="PT (INR)" />
                    <app-sk-test-checkbox code="APTT" label="PTT (APTT)" />
                </div>

                <div class="bordered no-border-bottom padding">
                    <app-sk-test-checkbox
                        code="LYTE4"
                        label="Electrolytes - Na, K, Cl, COz"
                    />
                    <app-sk-test-checkbox
                        code="CREAT"
                        label="Creatinine + eGFR"
                    />
                    <app-sk-test-checkbox code="UREA" label="Urea" />
                    <app-sk-test-checkbox
                        code="GLUCR"
                        label="Glucose - Random"
                    />
                    <app-sk-test-checkbox
                        name="GLUFA"
                        code="**GLUFA"
                        [codeBold]="true"
                        label="Glucose - FASTING"
                        [labelBold]="true"
                    />
                    <app-sk-test-checkbox code="HMA1C" label="Hemoglobin A1C" />
                    <div style="display: flex; flex-wrap: nowrap; gap: 1rem">
                        <app-sk-test-checkbox
                            code="CRCLE"
                            label="Est. Creatinine Clearance"
                        />
                        <div class="group" style="margin-top: 0">
                            <div style="margin-right: 10px">
                                <label>Weight:</label>
                            </div>
                            <div>
                                <input
                                    formControlName="CRCLE_weight"
                                    style="width: 150px"
                                    type="text"
                                />
                            </div>
                            <div>kg</div>
                        </div>
                    </div>
                </div>

                <div class="bordered no-border-bottom padding">
                    <app-sk-test-checkbox code="TRIG" label="Triglyceride" />
                    <app-sk-test-checkbox
                        code="CHOL"
                        label="Cholesterol-Total"
                    />
                    <div style="display: flex; flex-wrap: nowrap">
                        <app-sk-test-checkbox
                            code="LIPNF"
                            label="Chol, Trig, HDL, LDL, non-HDL"
                        />
                        <div>
                            <input
                                formControlName="LIPNF_value"
                                style="width: 100px"
                                type="text"
                            />
                        </div>
                    </div>
                    <app-sk-test-checkbox
                        code="GES1H"
                        label="Gestational Challenge (50 g) - Non Fasting"
                    />
                    <app-sk-test-checkbox
                        code="GES2H"
                        [codeBold]="true"
                        label="Gestational Tolerance (75 g) - FASTING"
                        [labelBold]="true"
                    />
                    <app-sk-test-checkbox
                        code="GTT2H"
                        [codeBold]="true"
                        label="Glucose Tolerance (75 g) - FASTING"
                        [labelBold]="true"
                    />
                </div>
                <div
                    style="display: flex; flex-direction: column; gap: 3px"
                    class="bordered no-border-bottom padding grow"
                >
                    <app-sk-test-checkbox code="ALB" label="Albumin" />
                    <app-sk-test-checkbox code="CA" label="Calcium" />
                    <app-sk-test-checkbox code="PHOS" label="Phosphate" />
                    <app-sk-test-checkbox code="MG" label="Magnesium" />
                    <app-sk-test-checkbox code="URIC" label="Uric Acid" />
                    <app-sk-test-checkbox
                        code="ALP"
                        label="Alkaline Phosphatase"
                    />
                    <app-sk-test-checkbox
                        code="ALT"
                        label="Alanine Aminotransferase"
                    />
                    <app-sk-test-checkbox
                        code="AST"
                        label="Aspartate Aminotransferase"
                    />
                    <app-sk-test-checkbox code="CK" label="CK - Total" />
                    <app-sk-test-checkbox code="LIP" label="Lipase" />
                    <app-sk-test-checkbox
                        code="GGT"
                        label="Gamma Glutamyltransferase"
                    />
                    <app-sk-test-checkbox
                        code="BILIT"
                        label="Bilirubin - Total"
                    />
                    <app-sk-test-checkbox
                        code="BILFR"
                        label="Bilirubin - Fractionation"
                    />
                    <app-sk-test-checkbox
                        code="BHCG"
                        label="BHCG (Quantitative - Level)"
                    />
                    <app-sk-test-checkbox
                        name="IRONB"
                        code="**IRONB"
                        [codeBold]="true"
                        label="Iron and Total Iron Binding Capacity"
                        [labelBold]="true"
                    />
                    <app-sk-test-checkbox code="FER" label="Ferritin" />
                    <app-sk-test-checkbox
                        code="PSA"
                        label="Prostate Specific Antigen"
                    />
                    <app-sk-test-checkbox
                        code="THYSA"
                        label="Thyroid Stimulating Hormone"
                    />
                    <app-sk-test-checkbox
                        code="FRT4"
                        label="Free T4 (Free Thyroxine)"
                    />
                    <app-sk-test-checkbox
                        code="АТРА"
                        label="Thyroid Peroxidase Antibody"
                    />
                    <app-sk-test-checkbox
                        code="FSHLH"
                        label="Follicle Stimulating Hormone/Luteinizing Hormone"
                    />
                    <app-sk-test-checkbox code="EDIOL" label="Estradiol" />
                    <app-sk-test-checkbox code="PRGE" label="Progesterone" />
                    <app-sk-test-checkbox code="PRL" label="Prolactin" />
                    <app-sk-test-checkbox code="WASER" label="Syphillis" />
                    <app-sk-test-checkbox code="HIV" label="HIV" />
                    <app-sk-test-checkbox
                        code="CRPH"
                        label="C-Reactive Protein-HS"
                    />
                    <app-sk-test-checkbox
                        code="RHF"
                        label="Rheumatoid Factor"
                    />
                    <app-sk-test-checkbox code="TNTHS" label="Troponin T HS" />
                    <app-sk-test-checkbox code="TP" label="Total Protein" />
                    <app-sk-test-checkbox
                        code="PES"
                        label="Serum Protein Electrophoresis"
                    />
                </div>
                <div class="bordered padding">
                    <app-sk-test-checkbox
                        code="FIT"
                        label="Stool for Fecal Immunochemical Test (Occult Blood)"
                    />
                    <div class="boder">
                        (Mark specimen with first & last name, health card #,
                        birthdate, and date of collection)
                    </div>
                </div>
            </div>

            <div style="display: flex; flex-direction: column">
                <div class="bordered no-border-bottom no-border-left padding">
                    <div class="bolder text-center">
                        Transfusion Medicine Testing
                    </div>
                    <div>
                        Transfusion Medicine Test Request Form (Form #101058)
                        must be completed by Most Responsible Health Provider.
                    </div>
                </div>
                <div class="bordered no-border-bottom no-border-left padding">
                    <div class="bolder text-center">Prenatal Blood Testing</div>
                    <app-sk-test-checkbox
                        code="PRNIM"
                        label="Prenatal Screen - Includes Rubella, Syphilis, HBV, HCV, HIV"
                    />
                    <app-sk-test-checkbox
                        code="PRENA"
                        label="Prenatal Group and Screen* (Expectant Patient)"
                    />
                    <app-sk-test-checkbox
                        code="PRENP"
                        label="Prenatal Group*, Phenotyping (Paternal Testing)"
                    />
                    <div class="bolder">
                        *SHA Request for Prenatal Testing must be completed
                    </div>
                </div>
                <div class="bordered no-border-bottom no-border-left padding">
                    <div style="display: flex">
                        <app-sk-test-checkbox
                            code="UA"
                            label="Voided Urinalysis"
                        />
                        <div style="width: 120px"></div>
                        <app-sk-test-checkbox
                            name="catheterizedUrinalysis"
                            label="Catheterized Urinalysis"
                        />
                    </div>
                    <app-sk-test-checkbox code="HCGU" label="HCG - Urine" />
                    <app-sk-test-checkbox
                        code="CLGP"
                        label="Urine for Chlamydia and G.C. - First stream"
                    />
                    <app-sk-test-checkbox
                        code="ALBCR"
                        label="Random Albumin/Creatinine Ratio (Microalbumin)"
                    />
                </div>
                <div class="bordered no-border-bottom no-border-left padding">
                    <div class="bolder text-center">
                        24 Hour Urine - Directions/container available at
                        collection sites
                    </div>
                    <div class="group" style="margin-top: 0">
                        <div style="margin-right: 10px">
                            <label class="no-break">Start Date:</label>
                        </div>
                        <div>
                            <input
                                formControlName="urineStartDate"
                                type="text"
                            />
                        </div>
                        <div style="margin-right: 10px">
                            <label>Time:</label>
                        </div>
                        <div>
                            <input
                                formControlName="urineStartTime"
                                type="text"
                            />
                        </div>
                    </div>
                    <div class="group" style="margin-top: 0">
                        <div style="margin-right: 10px">
                            <label class="no-break">End Date:</label>
                        </div>
                        <div>
                            <input formControlName="urineEndDate" type="text" />
                        </div>
                        <div style="margin-right: 10px">
                            <label>Time:</label>
                        </div>
                        <div>
                            <input formControlName="urineEndTime" type="text" />
                        </div>
                    </div>
                    <app-sk-test-checkbox code="CAUD" label="Calcium" />
                    <app-sk-test-checkbox code="CREUD" label="Creatinine" />
                    <div style="display: flex; gap: 10px">
                        <app-sk-test-checkbox
                            code="CRCL"
                            label="Creatinine Clearance"
                        />
                        <div class="bold">
                            *Must do blood creatinine as well *
                        </div>
                    </div>
                    <div style="display: flex; gap: 10px">
                        <app-sk-test-checkbox
                            code="CRCLC"
                            label="Creatinine Clearance (BSA Corrected)"
                        />
                        <div class="group" style="margin-top: 0">
                            <div style="margin-right: 10px">
                                <label class="no-break">Ht:</label>
                            </div>
                            <div>
                                <input formControlName="CRCLC_ht" type="text" />
                            </div>
                            <div style="margin-right: 10px">
                                <label>cm</label>
                            </div>
                        </div>
                        <div class="group" style="margin-top: 0">
                            <div style="margin-right: 10px">
                                <label class="no-break">Wt:</label>
                            </div>
                            <div>
                                <input formControlName="CRCLC_wt" type="text" />
                            </div>
                            <div style="margin-right: 10px">
                                <label>kg</label>
                            </div>
                        </div>
                    </div>
                    <app-sk-test-checkbox code="PO4UD" label="Phosphate" />
                    <app-sk-test-checkbox code="TPUD" label="Protein" />
                    <app-sk-test-checkbox
                        code="PEU"
                        label="Protein Electrophoresis"
                    />
                    <app-sk-test-checkbox
                        code="NAKUD"
                        label="Sodium / Potassium"
                    />
                    <app-sk-test-checkbox code="UREUD" label="Urea" />
                    <app-sk-test-checkbox code="URAUD" label="Uric Acid" />
                </div>
                <div class="bordered no-border-bottom no-border-left padding">
                    <div class="bolder text-center">
                        Hepatitis & CMV Serology
                    </div>
                    <div class="bold">
                        <div>
                            ✓ one box only. For other Hepatitis markers, please
                            order the 'other tests' section.
                        </div>
                        <div>
                            New reactive results will trigger additional tests.
                        </div>
                    </div>
                    <app-sk-test-checkbox
                        code="HEPPA"
                        label="Acute viral hepatitis undefined etiology"
                    />
                    <div style="padding-left: 120px">
                        (Hep A IgM, Hep B S Ag, Hep Bc IgM Ab, Hep C Ab)
                    </div>
                    <div class="bold">
                        <div>Chronic Viral Hepatitis:</div>
                    </div>
                    <app-sk-test-checkbox
                        code="HBCHR"
                        label="Hepatitis B (Hep B S.Ab, Hep B S Ag, Hep Bc Tot Ab)"
                    />
                    <app-sk-test-checkbox
                        code="HCAB"
                        label="Hepatitis C (Hep C Ab)"
                    />
                    <div class="bold">
                        <div>Hepatitis Immune Status:</div>
                    </div>
                    <app-sk-test-checkbox
                        code="HAABT"
                        label="Hepatitis A (Hep A Total Ab)"
                    />
                    <app-sk-test-checkbox
                        code="HBABS"
                        label="Hepatitis B (Hep B S Ab)"
                    />
                    <app-sk-test-checkbox
                        code="CMVA"
                        label="Acute CMV (CMV IgM)"
                    />
                    <app-sk-test-checkbox
                        code="CMVI"
                        label="Chronic or Past Exposure to CMV (CMV IgG)"
                    />
                </div>
                <div class="bordered no-border-left padding grow">
                    <div class="bolder text-center">Microbiology</div>
                    <div class="bold">
                        (Use alternate requisition for Virology/Comprehensive
                        Microbiology testing)
                    </div>
                    <app-sk-test-checkbox
                        name="BLOOD_CULTURE_CS"
                        codeWidth="300px"
                        code="BLOOD CULTURE"
                        label="C & S"
                    />
                    <app-sk-test-checkbox
                        name="CERVIX_SWAB_GC"
                        codeWidth="300px"
                        code="CERVIX SWAB"
                        label="G.C."
                    />
                    <div style="display: flex; gap: 30px; flex-wrap: nowrap">
                        <app-sk-test-checkbox
                            name="SPUTUM_CS"
                            codeWidth="300px"
                            code="SPUTUM"
                            label="C&S"
                        />
                        <app-sk-test-checkbox
                            name="SPUTUM_TB_AFB"
                            codeWidth="300px"
                            label="TB/AFB"
                        />
                    </div>
                    <div style="display: flex; gap: 30px; flex-wrap: nowrap">
                        <app-sk-test-checkbox
                            name="STOOL_CS"
                            codeWidth="300px"
                            code="STOOL"
                            label="C&S"
                        />
                        <app-sk-test-checkbox
                            name="STOOL_OP"
                            codeWidth="300px"
                            label="O&P"
                        />
                        <app-sk-test-checkbox
                            name="STOOL_CDIFF"
                            codeWidth="300px"
                            label="CDIFF"
                        />
                    </div>
                    <app-sk-test-checkbox
                        name="THROAT_CS"
                        codeWidth="300px"
                        code="THROAT"
                        label="C & S"
                    />
                    <app-sk-test-checkbox
                        name="URETHRAL_SWAB_GC"
                        codeWidth="300px"
                        code="URE THRAL SWAB"
                        label="G.C."
                    />
                    <div style="display: flex; gap: 30px; flex-wrap: nowrap">
                        <app-sk-test-checkbox
                            name="URINE_CATHETER_CS"
                            codeWidth="300px"
                            code="URINE - CATHETER"
                            label="C & S"
                        />
                        <app-sk-test-checkbox
                            name="URINE_CATHETER_YEAST"
                            codeWidth="300px"
                            label="YEAST"
                        />
                    </div>
                    <div class="group" style="margin-top: 0">
                        <div style="margin-right: 10px">
                            <label class="no-break">SOURCE:</label>
                        </div>
                        <div>
                            <input
                                formControlName="URINE_CATHETER_SOURCE"
                                type="text"
                            />
                        </div>
                    </div>
                    <div style="display: flex; gap: 30px; flex-wrap: nowrap">
                        <app-sk-test-checkbox
                            name="URINE_MIDSTREAM_CS"
                            codeWidth="300px"
                            code="URINE - MIDSTREAM"
                            label="C & S"
                        />
                        <app-sk-test-checkbox
                            name="URINE_MIDSTREAM_YEAST"
                            codeWidth="300px"
                            label="YEAST"
                        />
                    </div>
                    <div style="display: flex; gap: 30px; flex-wrap: nowrap">
                        <app-sk-test-checkbox
                            name="VAGINAL_BV"
                            codeWidth="300px"
                            code="VAGINAL"
                            label="BV"
                        />
                        <app-sk-test-checkbox
                            name="VAGINAL_TRICH"
                            codeWidth="300px"
                            label="TRICH"
                        />
                    </div>
                    <app-sk-test-checkbox
                        name="VAGINAL_GROUP_B_STREP_PREGNANCY_ONLY"
                        codeWidth="300px"
                        code="VAG/RECTAL SWAB"
                        label="GROUP B STREP - PREGNANCY ONLY"
                    />
                    <div class="group" style="margin-top: 0">
                        <div style="margin-right: 10px">
                            <label class="no-break">OTHER TEST:</label>
                        </div>
                        <div style="flex: 1">
                            <input formControlName="OTHER_TEST" type="text" />
                        </div>
                    </div>
                    <div class="group" style="margin-top: 0">
                        <div style="margin-right: 10px">
                            <label class="no-break">SOURCE:</label>
                        </div>
                        <div style="flex: 1">
                            <input
                                formControlName="OTHER_TEST_SOURCE"
                                type="text"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <ng-container *ngIf="templateVariant === 'lgv_paid'">
            <div style="margin-top: 20px; border: 1px solid #000; font-family: Calibri, Arial, sans-serif; font-size: 15px;">

                <!-- Page 2 header -->
                <div style="background: #99CBFD; padding: 10px 14px; font-weight: bold; font-size: 17px; border-bottom: 1px solid #000; -webkit-print-color-adjust: exact; print-color-adjust: exact;">
                    LifeLabs Contract — Page 2 (AX614)
                </div>

                <!-- Client Reference row -->
                <div style="display: grid; grid-template-columns: 160px 1fr; border-bottom: 1px solid #000;">
                    <div style="padding: 5px 10px; font-size: 14px; font-weight: bold; border-right: 1px solid #000; background: #f5f5f5;">Client Reference:</div>
                    <div style="padding: 5px 10px;">
                        <input formControlName="lgvPaid_clientReference" type="text" placeholder="Optional" style="width: 100%; margin-right: 0; border: none; border-bottom: 1px solid #aaa; font-size: 14px; background: transparent;" />
                    </div>
                </div>

                <!-- Health Number row -->
                <div style="display: grid; grid-template-columns: 160px 1fr; border-bottom: 1px solid #000;">
                    <div style="padding: 5px 10px; font-size: 14px; font-weight: bold; border-right: 1px solid #000; background: #f5f5f5;">Health Number:</div>
                    <div style="padding: 5px 10px; display: flex; flex-direction: column; gap: 4px;">
                        <input formControlName="lgvPaid_healthNumber" type="text" [attr.readonly]="lgvPaidSameAsPHN ? true : null" [style.color]="lgvPaidSameAsPHN ? '#888' : 'inherit'" [style.cursor]="lgvPaidSameAsPHN ? 'not-allowed' : 'text'" style="width: 100%; margin-right: 0; border: none; border-bottom: 1px solid #aaa; font-size: 14px;" />
                        <label style="display: flex; align-items: center; gap: 4px; font-size: 13px; color: #555; cursor: pointer;">
                            <input type="checkbox" [checked]="lgvPaidSameAsPHN" style="width: auto; margin-right: 0; border: none;" (change)="onHealthNumberSameAsPHN($any($event.target).checked)" />
                            Same as PHN on Lab Req
                        </label>
                    </div>
                </div>

                <!-- Ordering Doctor row -->
                <div style="display: grid; grid-template-columns: 160px 1fr; border-bottom: 1px solid #000;">
                    <div style="padding: 5px 10px; font-size: 14px; font-weight: bold; border-right: 1px solid #000; background: #f5f5f5;">Ordering Doctor:</div>
                    <div style="padding: 5px 10px; display: flex; align-items: center; gap: 6px;">
                        <input formControlName="lgvPaid_danTalya" type="checkbox" style="width: auto; margin-right: 0; border: none; cursor: pointer;" />
                        <span>Dan Talya, NP</span>
                    </div>
                </div>

                <!-- Fasting row -->
                <div style="padding: 6px 10px; border-bottom: 1px solid #000; display: flex; align-items: center; gap: 8px; flex-wrap: wrap;">
                    <span style="font-weight: bold; font-size: 14px;">Fasting</span>
                    <label style="display: flex; align-items: center; gap: 4px; cursor: pointer;">
                        <input formControlName="lgvPaid_fastingNo" type="checkbox" style="width: auto; margin-right: 0; border: none;" (change)="onLgvPaidFastingNoChange($any($event.target).checked)" /> No
                    </label>
                    <label style="display: flex; align-items: center; gap: 4px; cursor: pointer;">
                        <input formControlName="lgvPaid_fastingYes" type="checkbox" style="width: auto; margin-right: 0; border: none;" (change)="onLgvPaidFastingYesChange($any($event.target).checked)" /> Yes —
                    </label>
                    <input formControlName="lgvPaid_fastingHours" type="text" style="width: 36px; margin-right: 0; border: none; border-bottom: 1px solid #000; text-align: center;" /> hrs
                </div>

                <!-- Tests Requested header -->
                <div style="background: #99CBFD; text-align: center; font-weight: bold; font-size: 16px; padding: 5px; border-bottom: 1px solid #000; -webkit-print-color-adjust: exact; print-color-adjust: exact;">
                    TESTS REQUESTED
                </div>

                <!-- Documentation Fee -->
                <div style="padding: 8px 14px; border-bottom: 1px solid #000;">
                    <label style="display: flex; align-items: center; gap: 6px; cursor: pointer; font-weight: bold;">
                        <input formControlName="lgvPaid_docFee" type="checkbox" style="width: auto; margin-right: 0; border: none;" />
                        Documentation Fee (105)
                    </label>
                </div>

                <!-- SST Tube 1: SHBG — males only -->
                <div style="padding: 8px 14px; border-bottom: 1px solid #000;">
                    <div style="font-weight: bold; font-size: 14px; margin-bottom: 6px;">The following tests can be combined in one SST Tube</div>
                    <label *ngIf="!customerGender || customerGender === 'male' || customerGender === 'm'" style="display: flex; align-items: center; gap: 6px; cursor: pointer; padding-left: 8px;">
                        <input formControlName="lgvPaid_shbg" type="checkbox" style="width: auto; margin-right: 0; border: none;" />
                        SHBG
                    </label>
                </div>

                <!-- SST Tube per test: PSA Screening + Vitamin D -->
                <div style="padding: 8px 14px;">
                    <div style="font-weight: bold; font-size: 14px; margin-bottom: 6px;">The following tests require one SST tube per test</div>
                    <div style="display: flex; flex-direction: column; gap: 6px; padding-left: 8px;">
                        <label *ngIf="customerGender?.toLowerCase() !== 'female' && customerGender?.toLowerCase() !== 'f'" style="display: flex; align-items: center; gap: 6px; cursor: pointer;">
                            <input formControlName="lgvPaid_psaScreening" type="checkbox" style="width: auto; margin-right: 0; border: none;" />
                            PSA Screening (uninsured)
                        </label>
                        <label style="display: flex; align-items: center; gap: 6px; cursor: pointer;">
                            <input formControlName="lgvPaid_vitaminD25" type="checkbox" style="width: auto; margin-right: 0; border: none;" />
                            Vitamin D 25 (uninsured)
                        </label>
                        <label *ngIf="customerGender?.toLowerCase() === 'female' || customerGender?.toLowerCase() === 'f'" style="display: flex; align-items: center; gap: 6px; cursor: pointer;">
                            <input formControlName="lgvPaid_apob" type="checkbox" style="width: auto; margin-right: 0; border: none;" />
                            Apolipoprotein B (ApoB) (uninsured)
                        </label>
                    </div>
                </div>

            </div>
        </ng-container>
    </form>
</div>
